







import { defineComponent } from '@vue/composition-api';

const name = 'ttam-creative-general-deeplink-check';
export default defineComponent({
  name,
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onClick = () => {
      emit('click');
    };
    return {
      name,
      onClick,
    };
  },
});
